import { render, staticRenderFns } from "./refundPasswordSetting.vue?vue&type=template&id=79c12f08&scoped=true&"
import script from "./refundPasswordSetting.vue?vue&type=script&lang=js&"
export * from "./refundPasswordSetting.vue?vue&type=script&lang=js&"
import style0 from "./refundPasswordSetting.vue?vue&type=style&index=0&id=79c12f08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c12f08",
  null
  
)

export default component.exports